<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2024-03-06 10:16:11
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2024-03-08 15:32:30
 * @FilePath: /chaoyongtuan/src/views/shopManage/shopLibrary/addMaterial/components/good/tableCells/storeCell.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<div>
		<div v-if="multiType" class="omit">...</div>
		<div class="fz-12" v-else> 
			{{ row.shopName }}
		</div>
	</div>
</template>
<script>
import mixin from '@/components/tableCells/mixin.js';
export default {
	mixins: [mixin],
	data() {
		return {};
	},
	components: {
	
	},
	computed: {
		multiType(){
			return this.row.type;
		}
	},
	props: {},

	mounted() {},

	methods: {},
};
</script>
<style lang="less" scoped>
.omit{
	color: @color-b4
}
</style>


